<template>
    <header>
        <div class="row search-wrapper" :style="{ display: search.state ? 'flex' : 'none' }" v-if="search.active">
            <div class="col">
                <div class="search">
                    <i class="fa fa-search"></i>
                    <input type="text" placeholder="Aramak istediğiniz kelimeyi giriniz..." v-model="search.text" @keyup.enter="search.find" />
                </div>
            </div>
            <div class="col button-close" style="max-width:100px">
                <button class="btn btn-primary" @click="search.state = false"><i class="fa fa-times" /></button>
            </div>
        </div>
        <div class="row header-nav" :style="{ display: search.state ? 'none' : 'flex' }">
            <div class="col">
                <a class="btn-left-sidebar-open" data-bs-toggle="offcanvas" href="#leftSidebar" role="button" aria-controls="leftSidebar"><i class="fa fa-bars"></i></a>
                <div class="logo">
                    <router-link :to="Links.Url(Links.Home)" :title="appData.name" class="d-block">
                        <img :src="Web.Url(appData.default.logo)" :alt="appData.name" />
                    </router-link>
                </div>
            </div>
            <div class="col d-flex align-items-center">
                <a class="btn btn-danger ms-3 text-nowrap" target="_blank" href="https://www.rehberimsensin.com/" title="Web Sitesi"><i class="fa fa-house"></i></a>
                <a class="btn btn-danger ms-3 text-nowrap" target="_blank" href="https://app.rehberimsensin.com/" title="Portal Sistemi"><i class="fa fa-graduation-cap"></i></a>
            </div>
            <div class="col d-none">
                <button class="btn btn-primary" @click="search.state = true" v-if="search.active">
                    <i class="fa fa-search"></i>
                </button>
                <div class="search desktop" v-if="search.active">
                    <i class="fa fa-search"></i>
                    <input type="text" placeholder="Lütfen aramak istediğiniz kelimeyi giriniz..." v-model="search.text" @keyup.enter="search.find" />
                </div>
            </div>
            <div class="col">
                <div class="navbar-right">
                    <ul>
                        <li class="notification-dropdown dropdown" v-if="notification.active">
                            <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" @click="notification.saveRead">
                                <i class="fa fa-bell"></i>
                                <span class="count" v-if="notification.isNew"></span>
                            </button>
                            <div class="dropdown-menu">
                                <template v-if="notification.count > 0">
                                    <perfect-scrollbar style="max-height:25rem;">
                                        <router-link :to="Links.Url(Links.Notification.Card, r.Id)" class="dropdown-item" v-for="r in notification.data" :key="r.Id" :class="[ r.Okundu ? 'read' : 'unread' ]">
                                            <div class="dropdown-text">
                                                <p>{{ r.Konu }}</p>
                                                <span class="notification-date">{{D.DateTimeToString(r.Tarih)}}</span>
                                            </div>
                                        </router-link>
                                    </perfect-scrollbar>
                                    <router-link :to="Links.Url(Links.Notification.List)" class="dropdown-item">
                                        <div class="dropdown-text">
                                            <span class="all-notification">Tümünü Gör</span>
                                        </div>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <div class="dropdown-item">
                                        <div class="dropdown-text">
                                            <span class="not-found">Bildirim Bulunamadı</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </li>
                        <li class="btn-group">
                            <div>
                                <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
                                    <div class="user-box">
                                        <img :src="Web.Media(user.profile, Web.Url(appData.default.profile))" :alt="C.Str(user.fullName)" />
                                    </div>
                                    <span>{{ C.Str(user.fullName) }}</span>
                                </button>
                                <div class="dropdown-menu">
                                    <router-link :to="Links.Url(Links.Person.Profile)" class="dropdown-item"><i class="fa fa-user"></i><span>Profil</span></router-link>
                                    <router-link :to="Links.Url(Links.Setting.All)" class="dropdown-item"><i class="fa fa-gears"></i><span>Sistem Yönetimi</span></router-link>
                                    <div class="dropdown-divider"></div>
                                    <a href="javascript:void(0)" @click="logout" class="dropdown-item"><i class="fa fa-right-from-bracket"></i><span>Çıkış</span></a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
    import { reactive, toRefs, computed, onMounted } from "vue";
    import { useRouter } from "vue-router";
    import { useStore } from "vuex";

    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C, J, Text } from "@/helpers/global";
    import { Ajax, MethodType, Web } from "@/helpers/web";

    import { PerfectScrollbar } from "vue3-perfect-scrollbar";
    import { PersonService } from "@/services/api/person";

    import { StorePerson, StoreNotification } from "@/store/constants";


    export default {
        components: {
            PerfectScrollbar,
        },
        setup() {
            const router = useRouter();
            const store = useStore();

            const e = reactive({
                user: computed(() => {
                    return store.getters[StorePerson.get];
                }),
                search: {
                    active: false,
                    state: false,
                    text: "",
                    find() {
                        if (!Text.IsEmpty(e.search.text)) {
                            //router.push(Links.Url(Links.Search) + '?search=' + e.search.text.trim());
                            e.search.text = '';
                        }
                    },
                },
                isNewNotification: computed(() => {
                    return C.Int(store.getters[StoreNotification.getCountUnReaded]) > 0;
                }),
                logout() {
                    PersonService.Logout(true);
                },
                notification: {
                    active: false,
                    firstId: 0,
                    endId: 0,
                    data: [],
                    init() {
                        let s = J.Parse(sessionStorage.getItem('notification'), "{}");
                        if (s.list) {
                            e.notification.data = J.Clone(s.list);
                            e.notification.firstId = s.firstId;
                            e.notification.endId = s.endId;
                            if (e.notification.data.length > 0) {
                                e.notification.getNew();
                            }
                            else { e.notification.get(0); }
                        }
                        else { e.notification.get(0); }
                    },
                    saveSession() {
                        let s = {
                            firstId: e.notification.firstId,
                            endId: e.notification.endId,
                            list: e.notification.data,
                        };
                        sessionStorage.setItem("notification", J.String(s, "{}"));
                        setTimeout(function () { e.notification.getNew() }, 10000);
                    },
                    get(endId) {
                        Ajax.Api(MethodType.Get, Enums.SERVICE.BILDIRIM + '/first/' + endId, null).then((data) => {
                            let add = function (item) {
                                for (let j = 0; j < e.notification.data.length; j++) {
                                    if (e.notification.data[j].Id == item.Id) {
                                        return;
                                    }
                                }
                                e.notification.data.push(J.Clone(item));
                            };
                            for (let i = 0; i < data.List.length; i++) {
                                add(data.List[i]);
                            }
                            for (let i = 0; i < e.notification.data.length; i++) {
                                let r = e.notification.data[i];
                                if (r.Id > 0) {
                                    if (e.notification.firstId == 0) { e.notification.firstId = r.Id; }
                                    if (e.notification.endId == 0) { e.notification.endId = r.Id; }

                                    if (r.Id > e.notification.firstId) {
                                        e.notification.firstId = r.Id;
                                    }
                                    if (r.Id < e.notification.endId) {
                                        e.notification.endId = r.Id;
                                    }
                                }
                            }
                            e.notification.saveSession();
                        });
                    },
                    getNew() {
                        Ajax.Api(MethodType.Get, Enums.SERVICE.BILDIRIM + '/new/' + e.notification.firstId, null).then((data) => {
                            let add = function (item) {
                                for (let j = 0; j < e.notification.data.length; j++) {
                                    if (e.notification.data[j].Id == item.Id) {
                                        return;
                                    }
                                }
                                e.notification.data.push(J.Clone(item));
                            };
                            for (let i = 0; i < data.List.length; i++) {
                                add(data.List[i]);
                            }
                            for (let i = 0; i < e.notification.data.length; i++) {
                                let r = e.notification.data[i];
                                if (r.Id > 0) {
                                    if (e.notification.firstId == 0) { e.notification.firstId = r.Id; }
                                    if (e.notification.endId == 0) { e.notification.endId = r.Id; }

                                    if (r.Id > e.notification.firstId) {
                                        e.notification.firstId = r.Id;
                                    }
                                    if (r.Id < e.notification.endId) {
                                        e.notification.endId = r.Id;
                                    }
                                }
                            }
                            e.notification.saveSession();
                        });
                    },
                    saveRead() {
                        let status = false;
                        for (let i = 0; i < e.notification.data.length; i++) {
                            if (!e.notification.data[i].Okundu) {
                                status = true;
                                break;
                            }
                        }
                        if (status) {
                            Ajax.Api(MethodType.Put, Enums.SERVICE.BILDIRIM + "/readed", { FirstId: e.notification.firstId }, null).then((data) => {
                                for (let i = 0; i < e.notification.data.length; i++) {
                                    e.notification.data[i].Okundu = true;
                                }
                                e.notification.saveSession();
                            });
                        }
                    },
                    count: computed(() => {
                        return e.notification.data.length;
                    }),
                    isNew: computed(() => {
                        for (let i = 0; i < e.notification.data.length; i++) {
                            if (!e.notification.data[i].Okundu) {
                                return true;
                            }
                        }
                        return false;
                    }),
                    newCount: computed(() => {
                        let counter = 0;
                        for (let i = 0; i < e.notification.data.length; i++) {
                            if (!e.notification.data[i].Okundu) {
                                counter++;
                            }
                        }
                        return counter;
                    }),
                },
            });
            return { ...toRefs(e) };
        },
        mounted() {
        }
    };
</script>
